import React from 'react';
import { Modal } from 'antd';
import showSuccessNotification from '@client/utils/showSuccessNotification';

type PostAccountingItemsFailure = { customId: string; reasons: string[] };
type PostAccountingItemsResponse = { successes: string[]; failures: PostAccountingItemsFailure[] };

export const showPostAccountingItemsOutcome = (
	result: PostAccountingItemsResponse,
	verb: 'post' | 'unpost',
) => {
	const { successes, failures } = result;

	if (failures.length > 0) {
		Modal.warning({
			title: verb === 'post' ?
				'Some items could not be posted' :
				'Some items could not be unposted',
			width: 560,
			content: (
				<div>
					{failures.map((f) => (
						<div key={f.customId} style={{ marginBottom: 16 }}>
							<strong>{f.customId}</strong>
							<ul style={{ marginBottom: 0, paddingLeft: 20 }}>
								{f.reasons.map((reason) => (
									<li key={`${f.customId}-${reason}`}>{reason}</li>
								))}
							</ul>
						</div>
					))}
				</div>
			),
		});
	}

	if (successes.length > 0) {
		if (successes.length === 1) {
			showSuccessNotification(
				verb === 'post' ?
					'Successfully posted 1 item' :
					'Successfully unposted 1 item',
			);
		} else {
			showSuccessNotification(
				verb === 'post' ?
					`Successfully posted ${successes.length} items` :
					`Successfully unposted ${successes.length} items`,
			);
		}
	}
};
